import { Navigate, Outlet } from "react-router-dom";
import { useContext } from 'react';
import { AuthContext } from "../../context/AuthContex";
const SignInRoute = () => {
    const { isUserLogged } = useContext(AuthContext);
    return(
        isUserLogged ? <Navigate to="Admin" />: <Outlet /> 
    )
}
export default SignInRoute;